import React, { useEffect, useLayoutEffect, useState } from "react";
import { TaxtimePeriodRadioBtnsData } from "../../utils/constants";
import { monthData } from "../../utils/data";
import {
  calenderSetter,
  convertDateToObj,
  formatDateObj,
  get1stDate,
  getDateForCalender,
  getDatesObj,
  getDateToSend,
  // getDateToSend,
  getMonthForQuarter,
  monthFullNameArr,
} from "../../utils/functions";
import PerformanceCalender from "../PerformanceCalender/PerformanceCalender";
import EmptyButton from "../SelectButton/EmptyButton";
import FilledButton from "../SelectButton/FilledButton";
import SettingModalButton from "../SettingModalButton/SettingModalButton";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import { observer } from "mobx-react";
import { useParams } from "react-router";
import { useRef } from "react";
import Calender from "../Calender/Calender";

const PerformanceFilter = ({
  type,
  onClose,
  open,
  optionSelection,
  transacSelection,
  timePeriod,
  setTimePeriod,
  setOptionSelection,
  setTransacSelection,
  // localTransac,
  // localOption,
}) => {
  //const { selection, set } = localTransac;
  // const { selectionOption, setOption } = localOption;
  const { performanceRoute2 } = useParams();
  const [isStart, setisStart] = useState(true);

  // const [timePeriod, setTimePeriod] = useState({
  //   value: "",
  //   isSelected: false,
  // });

  const [asOfDate, setAsOfDate] = useState({
    date: "",
    month: "",
    year: "",
  });

  const [selectedFromDate, setSelectedFromDate] = useState({
    date: "",
    month: "",
    year: "",
  });
  const [selectedToDate, setSelectedToDate] = useState({
    date: "",
    month: "",
    year: "",
  });
  const [toSetCalFromDates, setToSetCalFromDates] = useState({
    startDay: "",
    prevMonthEndDate: "",
    thisMonthEndDate: "",
  });
  const [toSetCalToDates, setToSetCalToDates] = useState({
    startDay: "",
    prevMonthEndDate: "",
    thisMonthEndDate: "",
  });

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const fromDateWrapperRef = useRef(null);
  const toDateWrapperRef = useRef(null);

  const handleTransacSelection = (selectionValue) => {
    // if (
    //   (selection.id ? selection.id : transacSelection.id) !== selectionValue.id
    // ) {
    //   set({
    //     selectedType: selectionValue.value,
    //     id: selectionValue.id,
    //     isSelected: true,
    //   });
    // }

    if (transacSelection.id !== selectionValue.id) {
      setTransacSelection({
        selectedType: selectionValue.selectedType,
        id: selectionValue.id,
        isSelected: true,
      });
    }
  };

  const handleOptionsSelection = (selectionValue) => {
    // if (
    //   (selectionOption.id ? selectionOption.id : transacSelection.id) !==
    //   selectionValue.id
    // ) {
    //   setOption({
    //     selectedType: selectionValue.value,
    //     id: selectionValue.id,
    //     isSelected: true,
    //   });
    // }

    if (optionSelection.id !== selectionValue.id) {
      setOptionSelection({
        selectedType: selectionValue.selectedType,
        id: selectionValue.id,
        isSelected: true,
      });
    }
  };
  const performanceFilterTransaction = [
    { value: "Both", id: 0 },
    { value: "Stocks", id: 1 },
    { value: "Index", id: 2 },
  ];
  const performanceFilterOptions = [
    { value: "Both", id: "B" },
    { value: "Call", id: "C" },
    { value: "Put", id: "P" },
  ];

  const handleApplyFilter = () => {
    // PerformanceStore.setCurrentLoader("fullScreen");
    // AuthStore.updateLoadingFullScreen(true);
    // setTransacSelection(
    //   selection.selectedType ? { ...selection } : { ...transacSelection }
    // );
    // setOptionSelection(
    //   selectionOption.selectedType
    //     ? { ...selectionOption }
    //     : { ...optionSelection }
    // );
    // PerformanceStore.getFilterData(
    //   PerformanceStore.transacSelection.id,
    //   PerformanceStore.optionSelection.id,
    //   "",
    //   performanceRoute2
    // );

    PerformanceStore.setCurrentLoader("fullScreen");
    AuthStore.updateLoadingFullScreen(true);
    PerformanceStore.setFiltersSelection(
      "rememberedTransactionSelection",
      PerformanceStore.transacSelection
    );
    PerformanceStore.setFiltersSelection(
      "rememberedOptionSelection",
      PerformanceStore.optionSelection
    );

    const to = getDateToSend(selectedToDate);
    const from = getDateToSend(selectedFromDate);
    //PerformanceStore.setSecPageDuration("ITD");

    if (
      timePeriod.isSelected ||
      PerformanceStore.filterData.timePeriod.isSelected
    ) {
      PerformanceStore.setData(
        "filterData",
        timePeriod?.isSelected
          ? { timePeriod: timePeriod }
          : { timePeriod: PerformanceStore.filterData.timePeriod }
      );
      PerformanceStore.setPerformanceDate({ from: from, to: to });
      PerformanceStore.setDateInStore(selectedFromDate, selectedToDate);
      PerformanceStore.getFilterData(
        PerformanceStore.rememberedTransactionSelection.id,
        PerformanceStore.rememberedOptionSelection.id,
        // "withDate",
        // dateObj,
        "",
        performanceRoute2
      );
    } else {
      PerformanceStore.setData("filterData", {
        timePeriod: {
          value: "notSelected",
          isSelected: true,
        },
      });
      PerformanceStore.setPerformanceDate({ from: "", to: "" });
      PerformanceStore.getFilterData(
        PerformanceStore.rememberedTransactionSelection.id,
        PerformanceStore.rememberedOptionSelection.id,
        // "withoutDate",
        // dateObj,
        "",
        performanceRoute2
      );
    }

    // if (
    //   PerformanceStore.timePeriod.value !== "notSelected" &&
    //   PerformanceStore.timePeriod.isSelected
    // ) {
    //   PerformanceStore.setPerformanceDate({ from: from, to: to });
    //   PerformanceStore.setDateInStore(selectedFromDate, selectedToDate);

    //   PerformanceStore.getFilterData(
    //     PerformanceStore.rememberedTransactionSelection.id,
    //     PerformanceStore.rememberedOptionSelection.id,
    //     // "withDate",
    //     // dateObj,
    //     "",
    //     performanceRoute2
    //   );
    // } else {
    //   PerformanceStore.setPerformanceDate({ from: "", to: "" });
    //   PerformanceStore.getFilterData(
    //     PerformanceStore.rememberedTransactionSelection.id,
    //     PerformanceStore.rememberedOptionSelection.id,
    //     // "withoutDate",
    //     // dateObj,
    //     "",
    //     performanceRoute2
    //   );
    // }

    onClose();
  };

  const handleClose = () => {
    // setTransacSelection({ selectedType: "Both", id: 0, isSelected: true });
    // setOptionSelection({ selectedType: "Both", id: "B", isSelected: true });
    // PerformanceStore.setCurrentLoader("fullScreen");
    // AuthStore.updateLoadingFullScreen(true);
    // PerformanceStore.getFilterData(0, "B", "close", performanceRoute2);

    PerformanceStore.setFilterApplied("closeState");
    PerformanceStore.setPerformanceDate({ from: "", to: "" });
    setTransacSelection({ selectedType: "Both", id: 0, isSelected: true });
    setOptionSelection({ selectedType: "Both", id: "B", isSelected: true });
    PerformanceStore.setFiltersSelection("rememberedTransactionSelection", {
      selectedType: "Both",
      id: 0,
      isSelected: true,
    });
    PerformanceStore.setFiltersSelection("rememberedOptionSelection", {
      selectedType: "Both",
      id: "B",
      isSelected: true,
    });
    PerformanceStore.setData("filterData", {
      timePeriod: {
        value: "notSelected",
        isSelected: false,
      },
    });
    PerformanceStore.setTimePeriod(
      { value: "notSelected", isSelected: false },
      "changeWholeValue"
    );
    PerformanceStore.setCurrentLoader("fullScreen");
    AuthStore.updateLoadingFullScreen(true);
    PerformanceStore.getFilterData(
      0,
      "B",
      // "withoutDate",
      // "abc",
      "close",
      performanceRoute2
    );

    onClose();
  };

  const setCalendersDateOnDuration = (type, dateObj) => {
    const changedDate = new Date(
      dateObj.year,
      monthData.indexOf(dateObj.month)
    );
    changedDate.setDate(1);
    const newObj = {
      startDay: changedDate.getDay(),
      prevMonthEndDate: new Date(
        changedDate.getFullYear(),
        changedDate.getMonth(),
        0
      ).getDate(),
      thisMonthEndDate: new Date(
        changedDate.getFullYear(),
        changedDate.getMonth() + 1,
        0
      ).getDate(),
      nextMonthEndDate: new Date(
        changedDate.getFullYear(),
        changedDate.getMonth() + 2,
        0
      ).getDate(),
    };
    type === "from" ? setToSetCalFromDates(newObj) : setToSetCalToDates(newObj);
    //match
  };

  useLayoutEffect(() => {
    const oneDayDef = 86400000;
    const as_of_date =
      UserStore.asOfDate ||
      PerformanceStore.monthwiseData?.as_of_date ||
      PerformanceStore.secPageReturnData?.absoluteReturn?.as_of_date;
    const dateObjofAsOfDate = new Date(as_of_date);
    const toAsOfDate = {
      date: getDateForCalender(dateObjofAsOfDate.getDate()),
      month: monthData[dateObjofAsOfDate.getMonth()],
      year: dateObjofAsOfDate.getFullYear(),
    };
    const forCustomFirstDate = new Date(
      dateObjofAsOfDate.getTime() - oneDayDef
    );
    const fromDateCustome = {
      date: getDateForCalender(forCustomFirstDate.getDate()),
      month: monthData[forCustomFirstDate.getMonth()],
      year: forCustomFirstDate.getFullYear(),
    };

    if (isStart) {
      setisStart((prevState) => !prevState);
      setSelectedFromDate(fromDateCustome);
      setSelectedToDate(toAsOfDate);
      setCalendersDateOnDuration("from", fromDateCustome);
      setCalendersDateOnDuration("to", toAsOfDate);
    }
    // eslint-disable-next-line
  }, []);

  const ChangeCalederDates = (
    changedDate,
    compareWithDate,
    DateType,
    forFromLimitDate,
    minDate
  ) => {
    const setFromCalender = (date, arr) => {
      setSelectedFromDate(convertDateToObj(date, true));
      const finalDate = new Date(date);
      if (fromDateRef.current) {
        fromDateRef.current.setPreSelection(finalDate);
      }
      setToSetCalFromDates(getDatesObj(arr));
    };
    const setToCalender = (date, arr) => {
      setSelectedToDate(convertDateToObj(date, true));
      const finalDate = new Date(date);
      if (toDateRef.current) {
        toDateRef.current.setPreSelection(finalDate);
      }
      setToSetCalToDates(getDatesObj(arr));
    };

    calenderSetter(
      changedDate,
      compareWithDate,
      forFromLimitDate,
      minDate,
      selectedFromDate,
      DateType,
      setFromCalender,
      setToCalender
    );
  };

  useEffect(() => {
    const oneDayDef = 86400000;
    const as_of_date = UserStore.asOfDate;
    const dateObjofAsOfDate = new Date(as_of_date);
    const currentQuarter = new Date(
      `${dateObjofAsOfDate.getFullYear()}`,
      `${getMonthForQuarter(dateObjofAsOfDate.getMonth())}`
    );

    const forPreviousQaurterLast = new Date(
      currentQuarter.getTime() - oneDayDef
    );
    const forPreviousQaurterFirst = new Date(
      `${forPreviousQaurterLast.getFullYear()}`,
      `${getMonthForQuarter(forPreviousQaurterLast.getMonth())}`
    );

    const forThisMonth = new Date(get1stDate(dateObjofAsOfDate));
    const forPastMonthLastDate = new Date(forThisMonth.getTime() - oneDayDef);
    const forPastMonthFirstDate = new Date(get1stDate(forPastMonthLastDate));

    const forThisYearFirstDate = new Date(
      `${
        dateObjofAsOfDate.getMonth() - 3 < 0
          ? dateObjofAsOfDate.getFullYear() - 1
          : dateObjofAsOfDate.getFullYear()
      }-04`
    );
    const prevYearLastDate = new Date(
      forThisYearFirstDate.getTime() - oneDayDef
    );
    const prevYearFirstDate = new Date(
      `${prevYearLastDate.getFullYear() - 1}-04`
    );

    const fromCurMonth = {
      date: getDateForCalender(forThisMonth.getDate()),
      month: monthData[forThisMonth.getMonth()],
      year: forThisMonth.getFullYear(),
    };
    const toAsOfDate = {
      date: getDateForCalender(dateObjofAsOfDate.getDate()),
      month: monthData[dateObjofAsOfDate.getMonth()],
      year: dateObjofAsOfDate.getFullYear(),
    };
    const fromPrevMonth = {
      date: getDateForCalender(forPastMonthFirstDate.getDate()),
      month: monthData[forPastMonthFirstDate.getMonth()],
      year: forPastMonthFirstDate.getFullYear(),
    };
    const toPrevMonthLast = {
      date: getDateForCalender(forPastMonthLastDate.getDate()),
      month: monthData[forPastMonthLastDate.getMonth()],
      year: forPastMonthLastDate.getFullYear(),
    };
    const fromCurQuarter = {
      date: getDateForCalender(currentQuarter.getDate()),
      month: monthData[currentQuarter.getMonth()],
      year: currentQuarter.getFullYear(),
    };
    const fromPrevQuarter = {
      date: getDateForCalender(forPreviousQaurterFirst.getDate()),
      month: monthData[forPreviousQaurterFirst.getMonth()],
      year: forPreviousQaurterFirst.getFullYear(),
    };
    const toPrevQuarter = {
      date: getDateForCalender(forPreviousQaurterLast.getDate()),
      month: monthData[forPreviousQaurterLast.getMonth()],
      year: forPreviousQaurterLast.getFullYear(),
    };
    const fromCurFy = {
      date: getDateForCalender(forThisYearFirstDate.getDate()),
      month: monthData[forThisYearFirstDate.getMonth()],
      year: forThisYearFirstDate.getFullYear(),
    };
    const fromPrevFy = {
      date: getDateForCalender(prevYearFirstDate.getDate()),
      month: monthData[prevYearFirstDate.getMonth()],
      year: prevYearFirstDate.getFullYear(),
    };
    const toPrevFy = {
      date: getDateForCalender(prevYearLastDate.getDate()),
      month: monthData[prevYearLastDate.getMonth()],
      year: prevYearLastDate.getFullYear(),
    };
    setAsOfDate(toAsOfDate);

    let finalFromDate = null;
    let finalToDate = null;

    if (
      PerformanceStore.isFilterApplied &&
      isStart &&
      PerformanceStore.filterData.timePeriod.value !== "notSelected"
      // PerformanceStore.timePeriod.value !== "notSelected"
    ) {
      finalFromDate = PerformanceStore.fromDateStore;
      finalToDate = PerformanceStore.toDateStore;
      //setCalendersDateOnDuration("from", PerformanceStore.fromDateStore);
      //setCalendersDateOnDuration("to", PerformanceStore.toDateStore);
    } else {
      switch (
        timePeriod.value ||
        PerformanceStore.filterData.timePeriod.value
      ) {
        case "notSelected":
          finalFromDate = fromCurMonth;
          //setCalendersDateOnDuration("from", fromCurMonth);
          finalToDate = toAsOfDate;
          //setCalendersDateOnDuration("to", toAsOfDate);
          break;
        case "current_month":
          finalFromDate = fromCurMonth;
          //setCalendersDateOnDuration("from", fromCurMonth);
          finalToDate = toAsOfDate;
          //setCalendersDateOnDuration("to", toAsOfDate);
          break;
        case "previous_month":
          finalFromDate = fromPrevMonth;
          //setCalendersDateOnDuration("from", fromPrevMonth);
          finalToDate = toPrevMonthLast;
          //setCalendersDateOnDuration("to", toPrevMonthLast);
          break;

        case "current_quarter":
          finalFromDate = fromCurQuarter;
          //setCalendersDateOnDuration("from", fromCurQuarter);
          finalToDate = toAsOfDate;
          //setCalendersDateOnDuration("to", toAsOfDate);
          break;
        case "previous_quarter":
          finalFromDate = fromPrevQuarter;
          //setCalendersDateOnDuration("from", fromPrevQuarter);
          finalToDate = toPrevQuarter;
          //setCalendersDateOnDuration("to", toPrevQuarter);
          break;

        case "current_fy":
          finalFromDate = fromCurFy;
          //setCalendersDateOnDuration("from", fromCurFy);
          finalToDate = toAsOfDate;
          //setCalendersDateOnDuration("to", toAsOfDate);

          break;
        case "previous_fy":
          finalFromDate = fromPrevFy;
          //setCalendersDateOnDuration("from", fromPrevFy);
          finalToDate = toPrevFy;
          //setCalendersDateOnDuration("to", toPrevFy);
          break;

        case "custom":
          let fromDate = null;
          let toDate = null;
          if (!selectedFromDate.date) {
            fromDate = convertDateToObj(PerformanceStore.dateObj.from, true);
            toDate = convertDateToObj(PerformanceStore.dateObj.to, true);
          } else {
            fromDate = selectedFromDate;
            toDate = selectedToDate;
          }
          finalFromDate = fromDate;
          //setCalendersDateOnDuration("from", fromDate);
          finalToDate = toDate;
          //setCalendersDateOnDuration("to", toDate);

          break;
        default:
          finalFromDate = fromCurMonth;
          //setCalendersDateOnDuration("from", fromCurMonth);
          finalToDate = toAsOfDate;
          //setCalendersDateOnDuration("to", toAsOfDate);
          break;
      }
    }
    setSelectedFromDate(finalFromDate);
    setSelectedToDate(finalToDate);
    setCalendersDateOnDuration("from", finalFromDate);
    setCalendersDateOnDuration("to", finalToDate);
    fromDateRef.current.setPreSelection(new Date(formatDateObj(finalFromDate)));
    toDateRef.current.setPreSelection(new Date(formatDateObj(finalToDate)));
    // eslint-disable-next-line
  }, [timePeriod]);
  // [PerformanceStore.timePeriod]

  // useEffect(() => {
  //   if (open) {
  //     setTimePeriod({
  //       value: "",
  //       isSelected: false,
  //     });
  //   }

  // }, [open]);

  const getSelection = (value) => {
    if (timePeriod.value) {
      return value === timePeriod.value && timePeriod.isSelected;
    } else {
      return (
        value === PerformanceStore.filterData.timePeriod.value &&
        PerformanceStore.filterData.timePeriod.isSelected
      );
    }
  };

  // const getSelection = (localData, storeData, id) => {
  //   return localData || localData === 0 ? localData === id : storeData === id;
  // };

  return (
    <div className="performance_filter_main_container">
      <div
        style={{
          minHeight: "200px",
          maxHeight: "28vw",
          overflow: "auto",
          paddingRight: "10px",
        }}
        className="Perf_cont"
      >
        <div>
          {true && (
            <>
              <h2 className="date_title">By Date</h2>
              <div className="time_period_containers">
                {TaxtimePeriodRadioBtnsData?.map((data) => (
                  <div
                    className="timeperiod"
                    onClick={
                      () =>
                        data.value === timePeriod.value
                          ? setTimePeriod({
                              value: data.value,
                              isSelected: !timePeriod.isSelected,
                            })
                          : setTimePeriod({
                              value: data.value,
                              isSelected: true,
                            })
                      //  handleTimePeriodChange(data.value)
                    }
                  >
                    <button
                      style={{
                        padding: "0",
                        background: "transparent",
                        border: "none",
                      }}
                    >
                      {getSelection(data.value) ? (
                        <FilledButton />
                      ) : (
                        <EmptyButton />
                      )}
                    </button>

                    <h2> {data?.title}</h2>
                  </div>
                ))}
              </div>
              <div className="date_show_container">
                <div>
                  <h2>From Date</h2>
                  <h3>
                    {selectedFromDate?.date < 10 &&
                    selectedFromDate.length === 1
                      ? "0" + selectedFromDate?.date
                      : selectedFromDate?.date}{" "}
                    {selectedFromDate?.month?.substring(0, 3)}{" "}
                    {selectedFromDate?.year}
                  </h3>
                </div>
                <div>
                  <h2>To Date</h2>

                  <h3>
                    {" "}
                    {selectedToDate?.date < 10 && selectedToDate.length === 1
                      ? "0" + selectedToDate?.date
                      : selectedToDate?.date}{" "}
                    {selectedToDate?.month?.substring(0, 3)}{" "}
                    {selectedToDate?.year}
                  </h3>
                </div>
              </div>
              {false && (
                <div className="calender_container">
                  <div>
                    <PerformanceCalender
                      type={"from"}
                      selectedDate={selectedFromDate}
                      toSetCalDates={toSetCalFromDates}
                      dateLimit={
                        toSetCalFromDates.thisMonthEndDate +
                          toSetCalFromDates.startDay >
                        35
                          ? 42
                          : 35
                      }
                      changeCalenderDates={(
                        changedDate,
                        compareWithDate,
                        DateType,
                        limitDate,
                        minDate
                      ) =>
                        ChangeCalederDates(
                          changedDate,
                          compareWithDate,
                          DateType,
                          limitDate,
                          minDate
                        )
                      }
                      limitDate={
                        String(asOfDate.year) +
                        "-" +
                        `${
                          monthFullNameArr.indexOf(asOfDate.month) < 10
                            ? "0" + monthFullNameArr.indexOf(asOfDate.month)
                            : monthFullNameArr.indexOf(asOfDate.month)
                        }` +
                        "-" +
                        String(
                          `${
                            asOfDate.date < 10 && asOfDate.date?.length === 1
                              ? "0" + asOfDate.date
                              : asOfDate.date
                          }`
                        )
                      }
                      limitMonth={`${
                        monthData.indexOf(asOfDate.month) < 10
                          ? "0" + monthData.indexOf(asOfDate.month)
                          : monthData.indexOf(asOfDate.month)
                      }`}
                      limitYear={asOfDate.year}
                      imitDateForTo={
                        String(selectedToDate.year) +
                        "-" +
                        `${
                          monthFullNameArr.indexOf(selectedToDate.month) < 10
                            ? "0" +
                              monthFullNameArr.indexOf(selectedToDate.month)
                            : monthFullNameArr.indexOf(selectedToDate.month)
                        }` +
                        "-" +
                        String(
                          `${
                            selectedToDate.date < 10 &&
                            selectedToDate.date?.length === 1
                              ? "0" + selectedToDate.date
                              : selectedToDate.date
                          }`
                        )
                      }
                    />
                  </div>
                  <div>
                    <PerformanceCalender
                      type={"to"}
                      selectedDate={selectedToDate}
                      toSetCalDates={toSetCalToDates}
                      dateLimit={
                        toSetCalToDates.thisMonthEndDate +
                          toSetCalToDates.startDay >
                        35
                          ? 42
                          : 35
                      }
                      changeCalenderDates={(
                        changedDate,
                        compareWithDate,
                        DateType,
                        limitDate,
                        minDate
                      ) =>
                        ChangeCalederDates(
                          changedDate,
                          compareWithDate,
                          DateType,
                          limitDate,
                          minDate
                        )
                      }
                      limitDate={
                        String(asOfDate.year) +
                        "-" +
                        `${
                          monthFullNameArr.indexOf(asOfDate.month) < 10
                            ? "0" + monthFullNameArr.indexOf(asOfDate.month)
                            : monthFullNameArr.indexOf(asOfDate.month)
                        }` +
                        "-" +
                        String(
                          `${
                            asOfDate.date < 10 && asOfDate.date?.length === 1
                              ? "0" + asOfDate.date
                              : asOfDate.date
                          }`
                        )
                      }
                      limitMonth={`${
                        monthData.indexOf(asOfDate.month) < 10
                          ? "0" + monthData.indexOf(asOfDate.month)
                          : monthData.indexOf(asOfDate.month)
                      }`}
                      limitYear={asOfDate.year}
                    />
                  </div>
                </div>
              )}
              <div className="calender_container">
                <div>
                  <Calender
                    type={"from"}
                    selectedDate={selectedFromDate}
                    toSetCalDates={toSetCalFromDates}
                    dateLimit={
                      toSetCalFromDates.thisMonthEndDate +
                        toSetCalFromDates.startDay >
                      35
                        ? 42
                        : 35
                    }
                    changeCalenderDates={(
                      changedDate,
                      compareWithDate,
                      DateType,
                      limitDate,
                      minDate
                    ) =>
                      ChangeCalederDates(
                        changedDate,
                        compareWithDate,
                        DateType,
                        limitDate,
                        minDate
                      )
                    }
                    limitDate={
                      String(asOfDate.year) +
                      "-" +
                      `${
                        monthFullNameArr.indexOf(asOfDate.month) < 10
                          ? "0" + monthFullNameArr.indexOf(asOfDate.month)
                          : monthFullNameArr.indexOf(asOfDate.month)
                      }` +
                      "-" +
                      String(
                        `${
                          asOfDate.date < 10 && asOfDate.date?.length === 1
                            ? "0" + asOfDate.date
                            : asOfDate.date
                        }`
                      )
                    }
                    limitMonth={`${
                      monthData.indexOf(asOfDate.month) < 10
                        ? "0" + monthData.indexOf(asOfDate.month)
                        : monthData.indexOf(asOfDate.month)
                    }`}
                    limitYear={asOfDate.year}
                    //  minDate={minDate}
                    imitDateForTo={
                      String(selectedToDate.year) +
                      "-" +
                      `${
                        monthFullNameArr.indexOf(selectedToDate.month) < 10
                          ? "0" + monthFullNameArr.indexOf(selectedToDate.month)
                          : monthFullNameArr.indexOf(selectedToDate.month)
                      }` +
                      "-" +
                      String(
                        `${
                          selectedToDate.date < 10 &&
                          selectedToDate.date?.length === 1
                            ? "0" + selectedToDate.date
                            : selectedToDate.date
                        }`
                      )
                    }
                    ref={fromDateRef}
                    containerRef={fromDateWrapperRef}
                  />
                </div>
                <div>
                  <Calender
                    type={"to"}
                    selectedDate={selectedToDate}
                    toSetCalDates={toSetCalToDates}
                    dateLimit={
                      toSetCalToDates.thisMonthEndDate +
                        toSetCalToDates.startDay >
                      35
                        ? 42
                        : 35
                    }
                    changeCalenderDates={(
                      changedDate,
                      compareWithDate,
                      DateType,
                      limitDate,
                      minDate
                    ) =>
                      ChangeCalederDates(
                        changedDate,
                        compareWithDate,
                        DateType,
                        limitDate,
                        minDate
                      )
                    }
                    limitDate={
                      String(asOfDate.year) +
                      "-" +
                      `${
                        monthFullNameArr.indexOf(asOfDate.month) < 10
                          ? "0" + monthFullNameArr.indexOf(asOfDate.month)
                          : monthFullNameArr.indexOf(asOfDate.month)
                      }` +
                      "-" +
                      String(
                        `${
                          asOfDate.date < 10 && asOfDate.date?.length === 1
                            ? "0" + asOfDate.date
                            : asOfDate.date
                        }`
                      )
                    }
                    limitMonth={`${
                      monthData.indexOf(asOfDate.month) < 10
                        ? "0" + monthData.indexOf(asOfDate.month)
                        : monthData.indexOf(asOfDate.month)
                    }`}
                    limitYear={asOfDate.year}
                    //  minDate={minDate}
                    ref={toDateRef}
                    containerRef={toDateWrapperRef}
                  />
                </div>
              </div>
            </>
          )}

          <div className="by_transaction">
            <div className="titlle_wrapper">
              <h2 className="date_title">By Transaction Type</h2>
              {type !== "1" && <h2 className="date_title">By Option Type</h2>}
            </div>

            <div
              className={
                type === "1"
                  ? "select_box_container display_flex"
                  : "select_box_container"
              }
            >
              <div>
                {" "}
                {performanceFilterTransaction?.map((data) => (
                  <div
                    key={data.id}
                    className={
                      transacSelection.id === data.id &&
                      transacSelection.isSelected
                        ? //getSelection(selection.id, transacSelection.id, data.id)
                          "selected_border cursor"
                        : "cursor"
                    }
                    onClick={() => handleTransacSelection(data)}
                  >
                    <input
                      type="checkbox"
                      checked={
                        transacSelection.id === data.id &&
                        transacSelection.isSelected
                      }
                      //   checked={
                      //     optionSelection.id === data.id &&
                      //     optionSelection.isSelected
                      //     // getSelection(
                      //     // selection.id,
                      //     // transacSelection.id,
                      //     // data.id
                      // //  )
                      // }
                      onChange={() => handleTransacSelection(data)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") handleTransacSelection(data);
                      }}
                    />{" "}
                    <h2>{data.value}</h2>
                  </div>
                ))}
              </div>
              {type !== "1" && (
                <div>
                  {performanceFilterOptions?.map((data) => (
                    <div
                      key={data}
                      className={
                        optionSelection.id === data.id &&
                        optionSelection.isSelected
                          ? "selected_border cursor"
                          : "cursor"
                      }
                      // className={
                      //   optionSelection.id === data.id &&
                      //   optionSelection.isSelected
                      //   // getSelection(
                      //   //   selectionOption.id,
                      //   //   optionSelection.id,
                      //   //   data.id
                      //   // )
                      //     ? "selected_border cursor"
                      //     : "cursor"
                      // }
                      onClick={() => handleOptionsSelection(data)}
                    >
                      <input
                        type="checkbox"
                        checked={
                          optionSelection.id === data.id &&
                          optionSelection.isSelected
                        }
                        // checked={getSelection(
                        //   selectionOption.id,
                        //   optionSelection.id,
                        //   data.id
                        // )}
                        onChange={() => handleOptionsSelection(data)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter")
                            handleOptionsSelection(data);
                        }}
                      />{" "}
                      <h2>{data.value}</h2>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="btn_div">
        <button className="reset_btn" onClick={handleClose}>
          <h4>Reset</h4>
        </button>

        <SettingModalButton
          label={"Apply"}
          toggle={() => handleApplyFilter()}
        />
      </div>
    </div>
  );
};

export default observer(PerformanceFilter);
